import { render, staticRenderFns } from "./product-delete.vue?vue&type=template&id=38de7304&"
import script from "./product-delete.vue?vue&type=script&lang=js&"
export * from "./product-delete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports